// @ts-nocheck
import { useCompatQuery } from './useApolloCompat';
import {
  QUALIFICATIONS_QUERY,
  REVIEWS_QUERY,
  REVIEW_DETAIL_QUERY,
  KPIS_QUERY,
} from '../graphql/operations';

export function useQualifications(variables?: { page?: number; perPage?: number; type?: string }) {
  return useCompatQuery(QUALIFICATIONS_QUERY, { variables, notifyOnNetworkStatusChange: true });
}

export function useReviews(variables?: { page?: number; perPage?: number }) {
  return useCompatQuery(REVIEWS_QUERY, { variables, notifyOnNetworkStatusChange: true });
}

export function useReviewDetail(id: string) {
  return useCompatQuery(REVIEW_DETAIL_QUERY, { variables: { id }, skip: !id });
}

export function useKpis() {
  return useCompatQuery(KPIS_QUERY);
}
